<div *transloco="let t;" class="row">
  <div class="router-outlet relative">
    <div class="onboarding-bar" *ngIf="showOnboardingProgress">
      <div class="step-item" [ngClass]="{'selected': stepNumber==0, 'closed':stepNumber!==0}">
        <div class="checkmark-icon-border">
          <div class="checkmark-icon">
            <h1 *ngIf="!stepItem[0]">1</h1>
            <div class="checkmark-number" *ngIf="stepItem[0]">
              <img src="./assets/img/Icon/Checked-primary.svg">
            </div>
          </div>
        </div>
        <div class="checkmark-text">
          <h1>{{t('onboarding.findYourStarter')}}</h1>
          <p>{{t('onboarding.kryptomonUniqueMsg')}}</p>
        </div>
      </div>
      <div class="step-item" [ngClass]="{'selected': stepNumber==1, 'closed':stepNumber!==1}">
        <div class="checkmark-icon-border">
          <div class="checkmark-icon">
            <h1 *ngIf="!stepItem[1]">2</h1>
            <div class="checkmark-number" *ngIf="stepItem[1]">
              <img src="./assets/img/Icon/Checked-primary.svg">
            </div>
          </div>
        </div>
        <div class="checkmark-text">
          <h1>{{t('onboarding.getFirstLootbox')}}</h1>
          <p>{{t('onboarding.kryptomonFoodMsg')}}</p>
        </div>
      </div>
      <div class="step-item" [ngClass]="{'selected': stepNumber==2, 'closed':stepNumber!==2}">
        <div class="checkmark-icon-border">
          <div class="checkmark-icon">
            <h1 *ngIf="!stepItem[2]">3</h1>
            <div class="checkmark-number" *ngIf="stepItem[2]">
              <img src="./assets/img/Icon/Checked-primary.svg">
            </div>
          </div>
        </div>
        <div class="checkmark-text">
          <h1>{{t('shared.checkout')}}</h1>
          <p>{{t('onboarding.lastStepMsg')}}</p>
        </div>
      </div>
    </div>
    <div class="skip-button-wrapper">
      <div class="skip-button" (click)="startAgain()" *ngIf="showStartAgain">
        {{t('shared.restart')}}
      </div>
    </div>
    <!--<div class="skip-button right" *ngIf="showOnboardingProgress" (click)="skipOnboarding()">
      Skip
    </div>-->
    <div class="sidebar-menu-footer-links">
      <a href="https://www.kryptomon.co/privacy-policy" target="_blank">{{t('shared.privacyPolicy')}}</a>
      <a href="https://www.kryptomon.co/terms-of-services" target="_blank">{{t('shared.termsOfServices')}}</a>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>